module.exports = __webpack_public_path__ + "static/media/img1.d7d3fd7a.png";